import { Link } from "react-router-dom";

export default function ProjectTable({
    loading,
    data,
    currentPage,
    perPage,
    selectedRows,
    toggleAll,
    toggleRow,
}) {
    const startIdx = (currentPage - 1) * perPage;
    const allSelected = data.every((_, i) => selectedRows[startIdx + i]);

    return (
        <div className="table-responsive border">
            <table className="table align-middle mb-0">
                <thead className="bg-light">
                    <tr>
                        <th className="border">Project ID</th>
                        <th className="border">Title</th>
                        <th className="border">Buyer Name</th>
                        {/* <th className="border">Timeline</th> */}
                        <th className="border">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={3} className="text-center py-3">
                                Loading...
                            </td>
                        </tr>
                    ) : data.length > 0 ? (
                        data.map((item, index) => {
                            const globalIndex = startIdx + index;
                            return (
                                <tr key={globalIndex}>
                                    <td className="fw-semibold border text-primary">
                                        <Link
                                            to={`/seller-dashboard/communication/${item._id}`}
                                            className="text-black underline"
                                        >
                                            {item.groupId}
                                        </Link>
                                    </td>
                                    <td className="border ">
                                        {item.name}
                                    </td>
                                    <td className="border ">
                                        {item.buyerCompanyName}
                                    </td>
                                    {/* <td className="fw-semibold border text-primary">
                                        <div
                                            className="bg-light rounded-pill"
                                            style={{ height: 6, width: 120 }}
                                        >
                                            <div
                                                className="bg-success rounded-pill"
                                                style={{
                                                    width: `${item.progress || 0}%`,
                                                    height: "100%",
                                                }}
                                            />
                                        </div>
                                    </td> */}
                                    <td className="fw-semibold border text-primary">
                                        <div
                                            className="btn fw-semibold"
                                            style={{
                                                backgroundColor: "#F8F5FF",
                                                color: "#5014D0",
                                                borderRadius: "20px",
                                                padding: "4px 12px",
                                                fontSize: "0.85rem",
                                            }}
                                        >
                                            {item.status || "-"}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={3} className="text-center text-muted py-3">
                                No projects found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
